/**
 * ThemeScope — a View that puts the active light/dark palette in scope for
 * its subtree on every platform.
 *
 * On native, NativeWind tokens (`bg-paper-up`, `text-ink`, …) only resolve to
 * the dark palette under an ancestor carrying both the `dark` class and the
 * inline `vars()` map (see lib/themeVars.ts). Anything rendered outside the
 * root ThemedShell — overlays mounted beside the navigation Stack, such as
 * the in-app turn banner — must wrap itself in a ThemeScope, or it silently
 * falls back to the light `:root` values on iOS/Android while looking correct
 * on web (where the class lives on <html>).
 */

import React from 'react'
import { View, type ViewProps } from 'react-native'
import { useTheme } from '../../hooks/useTheme'
import { themeVarsDark, themeVarsLight } from '../../lib/themeVars'

export function ThemeScope({ className, style, ...rest }: ViewProps & { className?: string }) {
  const { theme } = useTheme()
  const dark = theme === 'dark'
  return (
    <View
      {...rest}
      className={[dark ? 'dark' : null, className].filter(Boolean).join(' ')}
      style={[style, dark ? themeVarsDark : themeVarsLight]}
    />
  )
}
